import SimpleArrowButton from '@components/bits/SimpleArrowButton';
import SimpleBlockContent from '@components/bits/SimpleBlockContent';
import useWindowDimensions from '@utils/hooks/useWindowDimension';
import iub from '@utils/ImageUrlBuilder';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

interface Size {
  width: number | undefined;
  height: number | undefined;
}
const previewImg =
  'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';

type Props = {
  tool;
};
const ToolsPreview: FunctionComponent<Props> = ({ tool: { desc, title, image } }) => {
  const size: Size = useWindowDimensions();
  const previewImage = image ? (
    <img
      alt={title}
      src={iub(image || previewImg)
        .width(size.width <= 768 ? 500 : 1000)
        .url()}
    />
  ) : (
    <img alt="forhåndsvisning" src={previewImg} />
  );

  return (
    <div className={`${styles.root}`}>
      {previewImage}
      {title && <h5>{title}</h5>}
      {desc && <SimpleBlockContent data={desc} />}
      <SimpleArrowButton text={'kjøp nå'} onClick={() => console.log('button click')} />
    </div>
  );
};

export default React.memo(ToolsPreview);
